// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import SearchResultsList from './results/SearchResultsList';
import SearchResultsError from './results/SearchResultsError';

const SearchPopupMain = (props) => {
    if (props.error) return <SearchResultsError {...props} />;
    return <SearchResultsList {...props} />;
};

SearchPopupMain.propTypes = {
    error: PropTypes.string,
};

export default SearchPopupMain;
